import { render } from "./ShiftBlock.vue?vue&type=template&id=b798e2ee&scoped=true"
import script from "./ShiftBlock.vue?vue&type=script&lang=js"
export * from "./ShiftBlock.vue?vue&type=script&lang=js"

import "./ShiftBlock.vue?vue&type=style&index=0&id=b798e2ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b798e2ee"]])

export default __exports__